var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 27.33H2.667A2.667 2.667 0 0 1 0 24.665V5.997a2.667 2.667 0 0 1 2.667-2.666h2.666V.664H8v2.667h8V.664h2.667v2.667h2.666A2.667 2.667 0 0 1 24 5.997v18.667a2.667 2.667 0 0 1-2.667 2.667Zm-18.666-16v13.334h18.666V11.331H2.667Zm0-5.333v2.667h18.666V5.997H2.667Zm8 16.552-4.943-4.942 1.885-1.886 3.058 3.058 5.724-5.724 1.885 1.885-7.61 7.608v.001Z",
    fill: "#DB2C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar_check.28bc038c796966bcaedadd5551e0872d.svg";
export { ForwardRef as ReactComponent };